/**
 * Actions for the GlobalModal component
 * Contains action creators that dispatch Redux actions to control modal visibility
 */
import { store } from '../../redux/store';
import { showModal, hideModal } from './reducer';
import { ModalMessage } from '../../interfaces/connected-components/globalModal';

/**
 * Shows the global modal with the specified configuration
 *
 * @param message - The message to display in the modal body
 * @param title - Optional title to display at the top of the modal
 * @param type - Modal type: 'info' (default) or 'question' which shows confirm/cancel buttons
 * @param onConfirm - Optional callback function when the confirm button is clicked
 * @param onReject - Optional callback function when the cancel button is clicked or overlay is clicked
 * @param customTopComponent - Optional function that returns a custom component to render at the top of the modal
 * @param confirmText - Optional text to display on the confirm button
 * @param rejectText - Optional text to display on the cancel button
 */
export const showGlobalModal = ({
  message,
  title = '',
  type = 'info',
  onConfirm,
  onReject,
  customTopComponent,
  confirmText,
  rejectText,
}: ModalMessage) => {
  store.dispatch(
    showModal({
      message,
      title,
      type,
      onConfirm,
      onReject,
      customTopComponent,
      confirmText,
      rejectText,
    }),
  );
};

/**
 * Closes the currently displayed global modal
 * Dispatches the hideModal action to the Redux store
 */
export const closeGlobalModal = () => {
  store.dispatch(hideModal());
};
